import { IError } from '@/types/error'

import settings from '@/settings/public'

export const logout = async () => {
  const res = await fetch(`${settings.api.host}/api/auth/logout`, {
    method: 'POST',
  })

  // Alone among the auth calls in useAuth.ts, this used to return the body
  // without checking it — so a 500 resolved as success. Callers that act on the
  // outcome (useForceLogout gates a partner scene on it) were told the session
  // was gone while it was still live.
  const response = await res.json().catch(() => ({}))

  if (!res.ok || response?.error) {
    const error = (response?.error ?? { message: `Logout failed with status ${res.status}` }) as IError

    // Flags a rejection the *server* produced. A fetch that throws — offline,
    // DNS, aborted — never reaches this line, and the two must not be handled
    // alike: dropping local state on a request that never left the device
    // leaves the visitor looking signed out while the session cookie is still
    // valid the moment they reconnect.
    throw Object.assign(error, { serverResponded: true })
  }

  return response
}
